import React, { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { laToday } from "../tm/tmConst";

/** 以银行交易凭据登记支票兑付；费用明细和支票登记簿共用同一表单与接口。 */
export function ManualCheckClearDialog({ api, check, zh, onClose, onDone }) {
  const [clearedDate, setClearedDate] = useState(check.clearedDate || laToday());
  const [evidence, setEvidence] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault();
    if (busy || !clearedDate || !evidence.trim()) return;
    setBusy(true); setError("");
    try {
      const { data } = await api.post(`/finance/checks/${encodeURIComponent(check.id)}/manual-clear`, {
        clearedDate, evidence: evidence.trim(), note: note.trim(),
      });
      onDone(data);
    } catch (err) {
      setError(err?.response?.data?.detail || err?.message || (zh ? "登记兑付失败，请重试" : "Unable to record clearing"));
    } finally { setBusy(false); }
  };
  return <Dialog open onOpenChange={(open) => { if (!open && !busy) onClose(); }}>
    <DialogContent data-testid="manual-clear-dialog" closeDisabled={busy} closeLabel={zh ? "关闭" : "Close"} className="max-w-lg">
      <DialogHeader>
        <DialogTitle>{zh ? `登记支票兑付 · #${check.checkNo}` : `Record check clearing · #${check.checkNo}`}</DialogTitle>
        <DialogDescription>{check.payee || "—"} · ${Number(check.amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</DialogDescription>
      </DialogHeader>
      <form onSubmit={submit} className="space-y-4">
        <p className="text-sm text-slate-600">{zh ? "请核对银行对账记录后登记实际兑付日期和凭据。" : "Confirm the bank transaction, then record the actual clearing date and evidence."}</p>
        <div>
          <label htmlFor="manual-clear-date" className="mb-1.5 block text-sm font-medium text-slate-700">{zh ? "银行兑付日期" : "Bank clearing date"} *</label>
          <Input id="manual-clear-date" data-testid="manual-clear-date" type="date" required value={clearedDate} disabled={busy} onChange={(e) => setClearedDate(e.target.value)} />
        </div>
        <div>
          <label htmlFor="manual-clear-evidence" className="mb-1.5 block text-sm font-medium text-slate-700">{zh ? "对账依据 / 银行流水号" : "Evidence / bank reference"} *</label>
          <Input id="manual-clear-evidence" data-testid="manual-clear-evidence" value={evidence} maxLength={500} required disabled={busy} onChange={(e) => setEvidence(e.target.value)} placeholder={zh ? "填写银行流水号或对账凭证" : "Bank transaction ID or statement reference"} />
        </div>
        <div>
          <label htmlFor="manual-clear-note" className="mb-1.5 block text-sm font-medium text-slate-700">{zh ? "备注（可选）" : "Note (optional)"}</label>
          <textarea id="manual-clear-note" data-testid="manual-clear-note" className="w-full min-h-20 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm focus-visible:outline-none focus-visible:border-brand-500 focus-visible:ring-[3px] focus-visible:ring-brand-500/20 disabled:opacity-50" maxLength={500} value={note} disabled={busy} onChange={(e) => setNote(e.target.value)} />
        </div>
        {error && <p role="alert" data-testid="manual-clear-error" className="text-sm text-destructive">{error}</p>}
        <DialogFooter>
          <Button type="button" variant="outline" disabled={busy} onClick={onClose}>{zh ? "取消" : "Cancel"}</Button>
          <Button type="submit" data-testid="manual-clear-submit" disabled={busy || !clearedDate || !evidence.trim()} className="bg-brand-500 hover:bg-brand-600 text-white">{busy ? (zh ? "登记中…" : "Saving…") : (zh ? "确认已兑付" : "Confirm cleared")}</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>;
}
